import React, { Component } from "react";
import propTypes from "prop-types";
import Loading from "../../Components/Loading";
import BackendClient from "../../BackendClient";

export default class ServiceContainer extends Component {
  static propTypes = {
    renderWidgetBlock: propTypes.func.isRequired
  };

  state = {
    isFetched: false,
    isFetching: false,
    hasError: false
  };

  componentDidMount() {
    const { isFetching, isFetched, hasError } = this.state;
    if (!(isFetched && isFetching && hasError)) {
      this.setState({ isFetching: true });
      BackendClient.getCarousels({
        expand: "items",
        "filter[key]": "services"
      })
        .fetchJson()
        .then(res => {
          if (res) {
            const items = (res[0] || {}).items || [];
            return this.setState({
              isFetching: false,
              isFetched: true,
              items
            });
          }
          return this.setState({
            hasError: true,
            isFetched: true,
            errorMessage: "Fetch error"
          });
        });
    }
  }

  render() {
    let content;
    const { isFetched, isFetching, hasError, errorMessage, items } = this.state;
    if (isFetched) {
      if (hasError) {
        content = <span className="text-error">{errorMessage}</span>;
      } else {
        content = (
          <ul className="services-list">
            {items
              .sort(({ order: orderPrev }, { order: orderNext }) => {
                if (orderPrev < orderNext) {
                  return -1;
                }
                if (orderPrev > orderNext) {
                  return 1;
                }
                return 0;
              })
              .map((item, idx) => (
                <li key={idx}>
                  <a href={item.link}>
                    <img src={item.url} alt={item.caption} />
                    <span
                      className="list-title"
                      dangerouslySetInnerHTML={{ __html: item.caption }}
                    />
                  </a>
                </li>
              ))}
          </ul>
        );
      }
    } else if (isFetching) {
      content = <Loading loading />;
    }

    return (
      <div className="services-wrapper">
        <div className="container">
          {this.props.renderWidgetBlock(
            "div",
            "frontend.home.notAuthorized.textServices"
          )}
          {content}
          {this.props.renderWidgetBlock(
            "div",
            "frontend.home.notAuthorized.goToTheWebsite"
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/main/services.jsx